export function listBlockPopups() {
    const popupBlock = ".list-block-popups-download";
    const _trigger = $(".list-block-item-btn.download");
    const _close = $(popupBlock).find(".close");

    _trigger.on("click",  function (event) {
        event.preventDefault();
        const _this = $(this);
        const _triggerId = _this.data("id");
        $(`${popupBlock}#${_triggerId}`).addClass("active");
    });

    _close.on("click", function (event) {
        event.preventDefault();
        const _this = $(this);
        _this.parents(popupBlock).removeClass("active");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/list-block-popups.js